import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuInput, NuMobileNumber, NuTextArea, NuUpload, SupplierNuInput } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import { useFormik } from 'formik';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseFetchCurrency from '../../../../Components/Hooks/useFetchCurrencyData';
import useFetchMetaStar from '../../../../Components/Hooks/useFetchMetaStar';
import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { CountryMIN } from '../../../../assets/CountryMini';
import CustomImgUpload from '../../../../Components/Utils/CustomImgUpload';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import axiosInstance from '../../../../Services/axiosCommon';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';

function EditContractors() {
  const {officeId,contractorsEditId} =useParams();
  
  const { value: desigination, getData: refdesigination } = useFetchMataData(
   `/dropdown/dropdown-details/`,
   "desigination"
 );
 const { value: DeliveryTerms, getData: refDeliveryTerms } = useFetchMataData(
   `/dropdown/dropdown-details/`,
   "Delivery_Terms_Contractor"
 );
 const { value: Category, getData: refCategory } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "Category_Contractor"
  );
 const { value: PaymentTerms, getData: refPaymentTerms } = useFetchMataData(
   `/dropdown/dropdown-details/`,
   "paymentTerms"
 );
 const { value: Rating } = useFetchMetaStar(
   `/dropdown/dropdown-details/`,
   "ratings"
 );
 const { value: Type, getData: refType } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "Type_Contractor"
);
const { value: Status, getData: refStatus } = useFetchMataData(
 `/dropdown/dropdown-details/`,
 "statusClient"
);
const { value: Designation, getData: refDesignation } = useFetchMataData(
 `/dropdown/dropdown-details/`,
 "desigination"
);
  //  const { value: currency } = UseFetchCurrency("/currency/drop-down");
   const [loading, setLoading] = useState(false);

   const [image, setImage] = useState({ preview: "", raw: "" });
   const location = useLocation();
   const data = location.state?.data;
   const from = location.state?.from;
   console.log(location.state, "state");
   const initialProducts = data?.products
     ? data.products.split(", ").map((p) => p.trim())
     : [];
   const [productList, setProductList] = useState(initialProducts);
   const productsString = productList.join(", ");
   const initialServices = data?.services
     ? data.services.split(", ").map((p) => p.trim())
     : [];
   const [servicesList, setServicesList] = useState(initialServices);
   const servicesString = servicesList.join(", ");
   const initialEmails = data?.emails
     ? data.emails.split(", ").map((p) => p.trim())
     : [];
   const [emailsList, setEmailsList] = useState(initialEmails);
   const emailsString = emailsList.join(", ");
   const { Oncancel, editFormData, contextHolder, isLoading } =
     useEditFormData();
   const [createNew, setCreateNew] = useState([]);

   function getView() {
    axiosInstance 
      .get(`/suppliers/${contractorsEditId}`)
      .then((res) => {
        setCreateNew({
          companyName:  res?.data?.data?.companyName,
          category:  res?.data?.data?.category,
          vendorType:  res?.data?.data?.vendorType,
          phoneWithCC:  res?.data?.data?.phoneWithCC,
          phoneCC:  res?.data?.data?.phoneCC,
          countryCode:  res?.data?.data?.phoneCC,
          refNumber:  res?.data?.data?.refNumber,
          phone: res?.data?.data?.phone,
          email:  res?.data?.data?.email,
          website:  res?.data?.data?.website,
          taxId: res?.data?.data?.taxId,
          paymentTerms: res?.data?.data?.paymentTerms,
          deliverTerms:  res?.data?.data?.deliverTerms,
          performanceRating:  res?.data?.data?.performanceRating,
          // contactPerson: data?.contactPerson,
          // designation: data?.designation,
          // cPMobileWithCC: data?.cPMobileWithCC,
          // cPMobileCC: data?.cPMobileCC,
          // cPMobile:data?.cPMobile,
          // contactPersonEmail: data?.contactPersonEmail,
          pcName:  res?.data?.data?.pcName,
          pcDesignation:  res?.data?.data?.pcDesignation,
          pcCountryCode:  res?.data?.data?.pcCountryCode,
          pcMobile:  res?.data?.data?.pcMobile,
          pcEmail:  res?.data?.data?.pcEmail,
          scCountryCode:  res?.data?.data?.scCountryCode,
          scDesignation:  res?.data?.data?.scDesignation,
          scMobile:  res?.data?.data?.scMobile,
          scName:  res?.data?.data?.scName,
          scEmail:  res?.data?.data?.scEmail,

          vendorStatus:  res?.data?.data?.vendorStatus,
    
          address1:  res?.data?.data?.address1,
          address2:  res?.data?.data?.address2,
          city:  res?.data?.data?.city,
          // cpDesigation:data?.cpDesigation,
          state: res?.data?.data?.state,
          postalCode: res?.data?.data?.postalCode,
          products: "",
          services: "",
          country:  res?.data?.data?.country,
          comments:  res?.data?.data?.comments,
          category:  res?.data?.data?.category,
          vendorType:  res?.data?.data?.vendorType,
          currencyId:  res?.data?.data?.currencyId,
          emails: "",
          vendorImage:  res?.data?.data?.vendorImage?.file,
          paymentTerms:  res?.data?.data?.paymentTerms,
          deliverTerms:  res?.data?.data?.deliverTerms,
          oldImage:  res?.data?.data?.vendorImage?.file,
          
    
    
          // isGeneral:  res.data?.data?.isGeneral ,
          // branchId:officeId,
   type:2,
        });       
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cdata) {
      getView();
    console.log(createNew,"createnew");

    // }
  }, [])

    const [inputKey, setInputKey] = useState(Date.now()); 
           
         
           const handleChangeImg = (e) => {
             if (e.target.files.length) {
               setImage({
                 preview: URL.createObjectURL(e.target.files[0]),
                 raw: e.target.files[0],
               });
             }
           };
         
           const handleImageRemove = () => {
             setImage({
               preview: "",
               raw: "",
             });
             setCreateNew((prevState) => ({ ...createNew, vendorImage: "" }));
             formik.values.vendorImage = "";
             formik.values.oldImage = "";
         
             setInputKey(Date.now()); 
           };

   // const handleChange = (event) => {
   //   const { value } = event.target;
   //   console.log("ss", typeof(value));
   //   let boolValue = (value === "true")
   //   console.log("test",boolValue);
     
   //   formik.setFieldValue("isGeneral", boolValue);
   // };
 
   const formik = useFormik({
     enableReinitialize: true,
     initialValues: createNew,
     validateOnChange: false,
     validateOnBlur: false,
     validationSchema: yup.object({
       // phone: yup
       //   .string()
       //   .matches(/^\d+$/, "Phone number must contain only digits")
       //   .min(9, "Phone number must be at least 9 digits")
       //   .max(11, "Phone number must be at most 11 digits")
       //   .required("Phone number is required"),
       //   cPMobile: yup
       //   .string()
       //   .matches(/^\d+$/, "Phone number must contain only digits")
       //   .min(9, "Phone number must be at least 9 digits")
       //   .max(11, "Phone number must be at most 11 digits")
       //   .required("Contact Phone number is required"),
       // email: yup.string().required("Email is required!"),
       // companyName: yup.string().required("Company Name is required!"),
       // // website: yup.string().required("Website is required!"),
       // cpName: yup.string().required("Contact Person is required!"),
     }),
     onSubmit: async (value, { resetForm }) => {
       // setLoading(true);
       let formData = new FormData();
       const valueWithProducts = {
         ...value,
         products: productsString,
         services: servicesString,
         emails: emailsString,
        
       };
       formData.append("json_data", JSON.stringify(valueWithProducts));
       formData.append("vendorImage", image.raw);
                                await editFormData({url:`/suppliers/edit-supplier/${contractorsEditId}`,formData:formData,navigateUrl:from ||`/contacts/main-contractors`,resetForm:resetForm   })

      //  editFormData(
      //    `/suppliers/edit-supplier/${contractorsEditId}`,
      //    formData,
      //    resetForm,
      //    from
      //  );
       // setLoading(false);
     },
   });
   const handleAddProducts = () => {
     const newProducts = formik.values.products
       .split(",")
       .map((p) => p.trim())
       .filter(Boolean);
     setProductList((prevList) => {
       const allProducts = [...prevList, ...newProducts];
       return Array.from(new Set(allProducts)); // Ensure unique products
     });
     formik.setFieldValue("products", "");
   };
 
   const handleDeleteProduct = (index) => {
     setProductList((prevList) => prevList.filter((_, i) => i !== index));
   };
 
   const handleAddServices = () => {
     const newServices = formik.values.services
       .split(",")
       .map((p) => p.trim())
       .filter(Boolean);
     setServicesList((prevList) => {
       const allServices = [...prevList, ...newServices];
       return Array.from(new Set(allServices)); // Ensure unique products
     });
     formik.setFieldValue("services", "");
   };
 
   const handleDeleteServices = (index) => {
     setServicesList((prevList) => prevList.filter((_, i) => i !== index));
   };
 
   const handleAddEmails = () => {
     const newEmails = formik.values.emails
       .split(",")
       .map((p) => p.trim())
       .filter(Boolean);
     setEmailsList((prevList) => {
       const allEmails = [...prevList, ...newEmails];
       return Array.from(new Set(allEmails)); // Ensure unique products
     });
     formik.setFieldValue("emails", "");
   };
 
   const handleDeleteEmails = (index) => {
     setEmailsList((prevList) => prevList.filter((_, i) => i !== index));
   };
 //   const handleChangeImg = (e) => {
 //     if (e.target.files.length) {
 //         setImage({
 //             preview: URL.createObjectURL(e.target.files[0]),
 //             raw: e.target.files[0],
 //         });
 //     }
 // };
 

 
   
   
 
   return (
     <div className="w-full h-full py-2 px-4 ">
       <div className="flex justify-between mb-4">
         {/* <Breadcrumb
           items={[
             {
               name: "Suppliers",
               link: `/main/${officeId}/contacts/suppliers`,
             },
             {
               name: "Edit ",
             },
           ]}
         /> */}
          <Breadcrumb
                  items={[
                    // { name: "Contacts" },
                    {
                      name: "Main-Contractors",
                      link:"/contacts/main-contractors"

                     
                    },
        
                    { name: "Edit" },
                  ]}
                />
         <BackButton />
       </div>
       <div className="w-full h-[calc(100vh-151px)] overflow-y-auto">
         <form onSubmit={formik.handleSubmit}>
           <div className="w-full mx-auto pb-4 bg-white rounded-md  ">
             <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
               <div className="w-full">
                                       <SettingHeading title={`Main-Contractors : ${createNew?.refNumber}` } />

               </div>
                 <CustomImgUpload
               key={inputKey}

                                                       borderStyle="dashed"
                                                       isRemove={true}
                                                       width='w-full md:w-1/2'
                                                       removeFunction={handleImageRemove}
                                                       handleChange={handleChangeImg}
                                                       preview={image.preview || createNew.vendorImage || ""}
                                                   />
               <NuInput
                                type="text"
                                label="Company"
                                placeholder="Company"
                                formik={formik}
                                name="companyName"
                                isRequired={true}
                                width="w-full md:w-1/2 lg:w-2/3"
                              />
                
                              <FormikSelectTwo
                                label="Category"
                                placeholder="Choose"
                                Options={Category}
                                formik={formik}
                                name="category"
                                width="w-full md:w-1/2 lg:w-1/3"
                                getFunc={refCategory}
                                displayProperty={"Category"}
                                propertyName={"Category_Contractor"}
                              />
                
                              <FormikSelectTwo
                                label="Type"
                                placeholder="Choose"
                                Options={Type}
                                formik={formik}
                                name="vendorType"
                                width="w-full md:w-1/2 lg:w-1/3"
                                getFunc={refType}
                                displayProperty={"Type"}
                                propertyName={"Type_Contractor"}
                              />
                
                              <NuMobileNumber
                                nunCode="countryCode"
                                label="Phone"
                                placeholder="Phone"
                                formik={formik}
                                name="phone"
                                isRequired={true}
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                              <NuInput
                                type="email"
                                label="Email"
                                placeholder="Email"
                                formik={formik}
                                name="email"
                                width="w-full md:w-1/2 lg:w-1/3"
                                isRequired={true}
                              />
                
                              <NuInput
                                type="text"
                                label="Website"
                                placeholder="Website"
                                formik={formik}
                                name="website"
                                // isRequired={true}
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                           
                              <NuInput
                                type="number"
                                label="Tax Id"
                                placeholder="Tax Id"
                                formik={formik}
                                name="taxId"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
               {/*  
                              <DropDownAddCurrency
                                label="Currency"
                                placeholder="Choose"
                                Options={currency}
                                formik={formik}
                                name="currencyId"
                                width="w-full md:w-1/2 lg:w-1/3"
                                getFunc={refCurrency}
                              /> */}
                
                              <FormikSelectTwo
                                label="Payment Terms"
                                placeholder="Choose"
                                Options={PaymentTerms}
                                formik={formik}
                                name="paymentTerms"
                                width="w-full md:w-1/2 lg:w-1/3"
                                getFunc={refPaymentTerms}
                                displayProperty={"Payment Terms"}
                                propertyName={"paymentTerms"}
                              />
                              <FormikSelectTwo
                                label="Delivery Terms"
                                placeholder="Choose"
                                Options={DeliveryTerms}
                                formik={formik}
                                name="deliverTerms"
                                width="w-full md:w-1/2 lg:w-1/3"
                                getFunc={refDeliveryTerms}
                                displayProperty={"Delivery Terms"}
                                propertyName={"Delivery_Terms_Contractor"}
                              />
                
                              <FormikSelectTwo
                                Options={Rating}
                                label="Ratings"
                                placeholder="Ratings"
                                formik={formik}
                                name="performanceRating"
                                width="w-full md:w-1/2 lg:w-1/3"
                               //  getFunc={refDeliveryTerms}
                                displayProperty={"Performance Rating"}
                                propertyName={"ratings"}
                              />
                               <FormikSelectTwo
                 label="Status"
                 placeholder="Choose"
                 Options={Status}
                 formik={formik}
                 name="vendorStatus"
                 width="w-full md:w-1/2 lg:w-1/3"
                 getFunc={refStatus}
                 displayProperty={"Status"}
                 propertyName={"statusClient"}
               />
                
                              {/* <NuUpload
                                label="Vendor Image"
                                width="w-full md:w-1/2 lg:w-1/3"
                                onChange={handleChangeImg}
                              /> */}
                
                              {/* <div className="w-full">
                                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                                  Contact Person Details :
                                </p>
                              </div>
                
                              <NuInput
                                type="text"
                                label="Name"
                                placeholder="Name"
                                formik={formik}
                                isRequired={true}
                                name="contactPerson"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                
                              <FormikSelectTwo
                                label="Designation"
                                placeholder="Choose"
                                Options={desigination}
                                formik={formik}
                                name="designation"
                                width="w-full md:w-1/2 lg:w-1/3"
                                getFunc={refdesigination}
                                displayProperty={"Designation"}
                                propertyName={"desigination"}
                              />
                
                              <NuMobileNumber
                                nunCode="cPMobileCC"
                                label="Contact Person Mobile"
                                placeholder="Contact Person Mobile"
                                formik={formik}
                                isRequired={true}
                                name="cPMobile"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                              <NuInput
                                type="email"
                                label="Contact Person Email"
                                placeholder="Contact Person Email"
                                formik={formik}
                                name="contactPersonEmail"
                                width="w-full md:w-1/2 lg:w-1/3"
                              /> */}
                            </div>
                          </div>
                          
                       <div className='sm:flex gap-2'>
                                               <div className="sm:w-[50%] mx-auto p-4 bg-white rounded-md mt-4 ">
                                               <div className=" w-full h-full flex justify-start content-start flex-wrap mb-4">
                                                 <div className="w-full">
                                                                                                      <SettingHeading title="Primary Contact "  />
                                                  
                                                 </div>
                                                 <NuInput
                                     type="text"
                                     label="Name"
                                     placeholder="Name"
                                     formik={formik}
                                     name="pcName"
                                     isRequired={true}
                                     width="w-full md:w-1/2 lg:w-1/2"
                                   />
                       
                       <FormikSelectTwo
                                     label="Designation"
                                     Options={Designation}
                                     formik={formik}
                                     placeholder="Choose"
                                     name="pcDesignation"
                                     width="w-full md:w-1/2 lg:w-1/2"
                                isRequired={true}
                                displayProperty={"Designation"}
                                     propertyName={"desigination"}
                       
                                 />
                       
                       <NuMobileNumber
                                     nunCode="pcCountryCode"
                                     label="Phone"
                                     placeholder="Phone"
                                     formik={formik}
                                     name="pcMobile"
                                     isRequired={true}
                       
                                     width="w-full md:w-1/2 lg:w-1/2"
                                   />
                       
                       <NuInput
                                     type="email"
                                     label="Email"
                                     placeholder="Email"
                                     formik={formik}
                                     name="pcEmail"
                                     isRequired={true}
                                     width="w-full md:w-1/2 lg:w-1/2"
                                   />
                                   
                                               </div>
                                               {/* <div className=" px-4 pb-2 flex gap-1">
                                                 <input
                                                   type="checkbox"
                                                   checked={useAddress}
                                                   onChange={handleAddress}
                                                 />
                                                 <label className=" text-xs">
                                                   Use Billing Address as Shipping Address
                                                 </label>
                                               </div> */}
                                             </div>
                                   
                                             <div className="sm:w-[50%] mx-auto p-4 bg-white rounded-md mt-4 ">
                                               <div className=" w-full h-full flex justify-start content-start flex-wrap mb-4">
                                                 <div className="w-full">
                                                                                                      <SettingHeading title="Secondary Contact"  />
                                                  
                                                 </div>
                                   
                                                 <NuInput
                                     type="text"
                                     label="Name"
                                     placeholder="Name"
                                     formik={formik}
                                     name="scName"
                                     isRequired={true}
                                     width="w-full md:w-1/2 lg:w-1/2"
                                   />
                       
                       <FormikSelectTwo
                                     label="Designation"
                                     Options={Designation}
                                     formik={formik}
                                     placeholder="Choose"
                                     name="scDesignation"
                                     width="w-full md:w-1/2 lg:w-1/2"
                                isRequired={true}
                                displayProperty={"Designation"}
                                     propertyName={"desigination"}
                       
                                 />
                       
                       <NuMobileNumber
                                     nunCode="scCountryCode"
                                     label="Phone"
                                     placeholder="Phone"
                                     formik={formik}
                                     name="scMobile"
                                     isRequired={true}
                       
                                     width="w-full md:w-1/2 lg:w-1/2"
                                   />
                       
                       <NuInput
                                     type="email"
                                     label="Email"
                                     placeholder="Email"
                                     formik={formik}
                                     name="scEmail"
                                     isRequired={true}
                                     width="w-full md:w-1/2 lg:w-1/2"
                                   />
                                               
                                               
                                             
                                             
                                   
                                               </div>
                                              
                                   
                                             </div>
                                            </div>
                          <div className="w-full mx-auto pb-4 bg-white rounded-md  mt-4">
                            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
                              <div className="w-full">
                                                                                   <SettingHeading title="Address"  />
                               
                              </div>
                
                              <NuInput
                                type="text"
                                label="Street Address Line 1"
                                placeholder="Street Address Line 1"
                                formik={formik}
                                name="address1"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                
                              <NuInput
                                type="text"
                                label="Street Address Line 2"
                                placeholder="Street Address Line 2"
                                formik={formik}
                                name="address2"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                
                              <NuInput
                                type="text"
                                label="City"
                                placeholder="City"
                                formik={formik}
                                name="city"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                
                              <NuInput
                                type="text"
                                label="State / Province"
                                placeholder="State / Province"
                                formik={formik}
                                name="state"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                
                              <NuInput
                                type="number"
                                label="Postal / Zip Code"
                                placeholder="Postal / Zip Code"
                                formik={formik}
                                name="postalCode"
                                width="w-full md:w-1/2 lg:w-1/3"
                              />
                
                              <FormikSelectTwo
                                type="text"
                                label="Country"
                                placeholder="Country"
                                Options={CountryMIN}
                                formik={formik}
                                name="country"
                                width="w-full md:w-1/2 lg:w-1/3"
                                FixPosition={false}
                                PortalTarget={false}
                              />
                
                              <NuTextArea
                                label="Comments"
                                placeholder="Comments"
                                formik={formik}
                                name="comments"
                                width="w-full md:w-1/2 "
                                new_width="lg:w-2/3"
                              />
             </div>
             <div className="w-full my-4 mt-8 ">
                             <div className="flex justify-end gap-4">
                               <CancelButton
                                 handleClick={() => {
                                   Oncancel(-1);
                                 }}
                               />
                               <SubmitButton isLoading={isLoading} />
                             </div>
                           </div>
           </div>
           
         </form>
       </div>
     </div>
   );
}

export default EditContractors
